import { SwitchEvent } from '@nextui-org/react';
import React from 'react';

import HelpTooltip from '../HelpTooltip';
import { Container, Description, RowContainer, StyledSwitch, Title } from './Switch.styles';

interface SwitchProps {
  checked: boolean;
  onChange?: (e: SwitchEvent) => void;
  title?: string;
  description?: string;
  disabled?: boolean;
  helpText?: string;
}

const Switch = ({ title, description, helpText, ...props }: SwitchProps) => {
  return (
    <Container>
      <RowContainer>
        <StyledSwitch size="xs" animated={false} {...props} />
        {title && <Title>{title}</Title>}
        {helpText && <HelpTooltip $helpText={helpText} />}
      </RowContainer>
      {description && <Description>{description}</Description>}
    </Container>
  );
};

export default Switch;
